import React, { SetStateAction, Dispatch } from "react";
import Button from "@awsui/components-react/button";
import { useMutation } from "react-query";
import { FlashbarProps } from "@awsui/components-react/flashbar/interfaces";
import addCompetition from "api/addCompetition";
import Box from "@awsui/components-react/box";
import {useAuth} from "hooks/useAuth";
import NewCompetition from "model/admin/NewCompetition";


interface AddCompetitionButtonProps {
    competition: NewCompetition;
    setCompetition: Dispatch<SetStateAction<NewCompetition>>;
    buttonEnabled: boolean;
    setButtonEnabled: Dispatch<SetStateAction<boolean>>;
    setSubmitMessage: Dispatch<SetStateAction<FlashbarProps.MessageDefinition | undefined>>;
}

const AddCompetitionButton: React.FC<AddCompetitionButtonProps> = (props) => {

    const competition = props.competition;
    const [{user}] = useAuth();

    const {
        mutate: addCompetitionMutation,
        isLoading: addCompetitionIsLoading
    } = useMutation((competition: NewCompetition) => addCompetition(competition, user?.token), {
        onSuccess: () => {
            props.setSubmitMessage({
                header: "Competition added correctly",
                type: "success",
                content: "",
            })
        },
        onError: () => {
            props.setSubmitMessage({
                header: "Error when adding competition",
                type: "error",
                content: "Try to refresh the page.",
            })
        },
        onSettled: () => {
            props.setButtonEnabled(false);
            props.setCompetition({});
        }
    }
    );

    const submitCompetition = () => {
        addCompetitionMutation(competition);
    }

    return (
        <Box float="right">
            <Button
                disabled={!props.buttonEnabled || Object.keys(competition).length === 0}
                iconAlign="left"
                loading={addCompetitionIsLoading}
                variant="primary"
                onClick={submitCompetition}
            >
                Submit
            </Button>
        </Box>
    );
};

export default AddCompetitionButton;
